import { Modifier } from '@apollo/client/cache/core/types/common';

export const requestForOrdersPopperModifiers:
  | readonly Partial<Modifier<unknown | object>>[]
  | undefined = [
  {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn({
      state,
    }: {
      state: {
        rects: { reference: { width: string } };
        styles: { popper: { minWidth: string; maxWidth: string } };
      };
    }): void {
      state.styles.popper.minWidth = `${state.rects.reference.width}px`;
      state.styles.popper.maxWidth = `${state.rects.reference.width}px`;
    },
    effect({
      state,
    }: {
      state: {
        elements: {
          reference: { offsetWidth: string };
          popper: { style: { minWidth: string; maxWidth: string } };
        };
      };
    }): void {
      state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`;
      state.elements.popper.style.maxWidth = `${state.elements.reference.offsetWidth}px`;
    },
  },
];
